// lib
import React from "react";
// src
import { COLORS } from "utils/colors";

const style = (c) => ({
  backgroundColor: c,
  border: `1px solid ${c}`,
});

const colorBox = (c) => (
  <div key={c} className="color-box" style={style(c)}>
    <span>{c}</span>
    <p>
      Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim
      id est laborum.
    </p>
  </div>
);

export default () => {
  return (
    <main>
      <div className="admin-colors">{COLORS.map(colorBox)}</div>
    </main>
  );
};
